// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;Your majesty above the heavens is praised&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;out of the mouths of babes at the breast.<br> </p> </div></div>";
// Exports
module.exports = code;